
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from "@sentry/angular";

import "hammerjs"; // Including hammerJS to our app

if (environment.production) {
  enableProdMode();

  // Silence noisy console output in production; keep warn/error for real issues.
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.trace = () => {};
}

// Only enable Sentry in production/staging (not localhost)
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

Sentry.init({
  dsn: "https://3a82483c503d9bdeebfe4229ef484066@o4509534162386944.ingest.de.sentry.io/4509534164484176",
  // Disable Sentry in localhost/development
  enabled: environment.production && !isLocalhost,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    /^https:\/\/corpers\.ng/,
  ],
  // Set environment tag for better filtering in Sentry dashboard
  environment: environment.production ? 'production' : 'development',
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
